import { render, staticRenderFns } from "./LaboratoryResultsView.vue?vue&type=template&id=d4d20622&"
import script from "./LaboratoryResultsView.vue?vue&type=script&lang=js&"
export * from "./LaboratoryResultsView.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryResultsView.vue?vue&type=style&index=0&id=d4d20622&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports